import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useRemoveModalConstants = () => {
   const { t } = useTranslation();

   const REMOVE_MODAL_CONSTANTS = useMemo(
      () => ({
         NO_PALLETS_COMMERCIAL_NETWORK: t('remove_modal.no_pallets_commercial_network'),
         PALLETS_EXIST_COMMERCIAL_NETWORK: t('remove_modal.pallets_exist_commercial_network'),
         PALLETS_EXIST_DISTRIBUTION_CENTER: t('modals.deleteStorage.withPallets.message1'),
         NO_PALLETS_DISTRIBUTION_CENTER: t('remove_modal.no_pallets_distribution_center'),
      }),
      [t],
   );

   return { REMOVE_MODAL_CONSTANTS };
};
